/** Money is integer paise everywhere. These helpers convert to and from what people type and read. */

/** 250000 → "₹2,500.00" (Indian digit grouping). */
export function formatRupees(paise: number, opts: { hideZeroFraction?: boolean } = {}): string {
  const negative = paise < 0;
  const abs = Math.abs(Math.round(paise));
  const rupees = Math.floor(abs / 100);
  const fraction = abs % 100;
  const whole = rupees.toLocaleString('en-IN');
  const body = opts.hideZeroFraction && fraction === 0 ? whole : `${whole}.${String(fraction).padStart(2, '0')}`;
  return `${negative ? '-' : ''}₹${body}`;
}

/**
 * "2,500.5" → 250050. Parsed as text, never through floating point (0.1 + 0.2 style errors are
 * unacceptable for money). Returns null for anything that is not a plain amount with at most 2 decimals.
 */
export function parseRupees(input: string): number | null {
  const t = input.replace(/[,\s₹]/g, '');
  if (!/^\d+(\.\d{1,2})?$/.test(t)) return null;
  const [whole, frac = ''] = t.split('.');
  const paise = Number(whole) * 100 + Number(frac.padEnd(2, '0'));
  return Number.isSafeInteger(paise) ? paise : null;
}

/** 250000 → "2500" / 250050 → "2500.50", for pre-filling an input. */
export function paiseToInput(paise: number): string {
  if (!paise) return '';
  const whole = Math.floor(paise / 100);
  const frac = paise % 100;
  return frac ? `${whole}.${String(frac).padStart(2, '0')}` : String(whole);
}
